(function ($) {
  //loadPosts();
  $(".hero-carousel__content").slick({
    dots: true,
    infinite: true,
    fade: true,
    arrows: false,
    //autoplay: true,
    appendDots: $(".dots-wrapper")
  });
  $(".product-categories-carousel__slider").slick({
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  });
  $(".products-carousel__slider").slick({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  });
  $(".recipes-quad__carousel").slick({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  });
  $(".product__gallery-large").slick({
    fade: true,
    arrows: false,
    asNavFor: ".product__gallery-carousel"
  });
  $(".product__gallery-carousel").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".product__gallery-large",
    focusOnSelect: true,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }]
  });
  $(".news-carousel__slider").slick({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  });
  $(".recipes-quad__grid").slick({
    mobileFirst: true,
    responsive: [{
      breakpoint: 480,
      settings: "unslick"
    }]
  });

  // $(".product-tabs__nav").slick({
  //   mobileFirst: true,
  //   infinite: false,
  //   responsive: [
  //     {
  //       breakpoint: 480,
  //       settings: "unslick",
  //     },
  //   ],
  // });
  // $(".product-tabs__nav").on(
  //   "beforeChange",
  //   function (event, slick, currentSlide) {
  //     console.log("hola");
  //     const $currentSlide = $(slick.$slides.get(currentSlide + 1));
  //     $currentSlide.trigger("click");
  //   }
  // );

  $(".product__details-list").slick({
    mobileFirst: true,
    infinite: false,
    slidesToShow: 2,
    responsive: [{
      breakpoint: 480,
      settings: "unslick"
    }]
  });
})(jQuery);
setTimeout(function () {
  document.querySelector("body").classList.add("loaded");
}, 800);
scrollDown();
window.addEventListener("scroll", function (e) {
  scrollDown();
});
const tab_links = document.querySelectorAll(".tabs__nav a");
if (tab_links) {
  const tabs = document.querySelectorAll(".tab");
  tab_links.forEach(tab_link => {
    tab_link.addEventListener("click", function (e) {
      e.preventDefault();
      const target = tab_link.getAttribute("href");
      console.log(target);
      tabs.forEach(element => {
        element.classList.remove("active", "in");
      });
      document.getElementById(target).classList.add("active");
      setTimeout(() => {
        document.getElementById(target).classList.add("in");
      }, 50);
      tab_links.forEach(tab_link => {
        tab_link.classList.remove("active");
      });
      tab_link.classList.add("active");
    });
  });
}

// Tabs funcionality for mobile select
const tabsSelect = document.querySelector(".tabs__mobile-nav");
if (tabsSelect) {
  const tabs = document.querySelectorAll(".tab");
  const tab_links = document.querySelectorAll(".tabs__nav a");
  tabsSelect.addEventListener("change", function () {
    const target = this.value;
    console.log(target);

    // Remove active classes from all tabs
    tabs.forEach(element => {
      element.classList.remove("active", "in");
    });

    // Add active class to selected tab
    document.getElementById(target).classList.add("active");
    setTimeout(() => {
      document.getElementById(target).classList.add("in");
    }, 50);

    // Update active class on desktop tab links for consistency
    tab_links.forEach(tab_link => {
      tab_link.classList.remove("active");
      if (tab_link.getAttribute("href") === target) {
        tab_link.classList.add("active");
      }
    });
  });

  // Sync the select with the active tab when tabs are clicked
  if (tab_links.length > 0) {
    tab_links.forEach(tab_link => {
      tab_link.addEventListener("click", function () {
        const target = tab_link.getAttribute("href");
        tabsSelect.value = target;
      });
    });
  }
}
const accordionItem = document.querySelectorAll(".accordion-item");
if (accordionItem) {
  accordionItem.forEach(item => {
    const accordionHeader = item.querySelector(".accordion-item__title");
    accordionHeader.addEventListener("click", () => {
      const accordionBody = item.querySelector(".accordion-item__content");
      const isActive = item.classList.contains("active");
      if (isActive) {
        item.classList.remove("active");
        accordionBody.style.maxHeight = null;
      } else {
        item.classList.add("active");
        accordionBody.style.maxHeight = accordionBody.scrollHeight + "px";
      }
    });
  });
}
document.addEventListener("DOMContentLoaded", function () {
  const shareBtn = document.querySelector(".btn--share");
  const sharePopover = document.getElementById("sharePopover");
  const shareOptions = document.querySelectorAll(".share-option");
  if (shareBtn) {
    const copyMessage = document.createElement("div");
    copyMessage.className = "copy-message";
    copyMessage.textContent = "Enlace copiado al portapapeles";
    document.body.appendChild(copyMessage);

    // Mostrar/ocultar popover
    shareBtn.addEventListener("click", function (e) {
      e.preventDefault();
      sharePopover.classList.toggle("active");
    });

    // Cerrar popover al hacer clic fuera
    document.addEventListener("click", function (e) {
      if (!sharePopover.contains(e.target) && e.target !== shareBtn) {
        sharePopover.classList.remove("active");
      }
    });

    // Funcionalidad para compartir
    shareOptions.forEach(option => {
      option.addEventListener("click", function (e) {
        e.preventDefault();
        const platform = this.getAttribute("data-platform");
        const currentUrl = window.location.href;
        const title = document.querySelector(".share-header h1").textContent;
        const image = document.querySelector(".share-featured-image img").getAttribute("src");
        switch (platform) {
          case "facebook":
            window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`, "facebook-share", "width=580,height=296");
            break;
          case "whatsapp":
            window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(title + " " + currentUrl)}`, "whatsapp-share", "width=580,height=296");
            break;
          case "twitter":
            window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(currentUrl)}`, "twitter-share", "width=580,height=296");
            break;
          case "pinterest":
            window.open(`https://pinterest.com/pin/create/button/?url=${encodeURIComponent(currentUrl)}&media=${encodeURIComponent(image)}&description=${encodeURIComponent(title)}`, "pinterest-share", "width=580,height=296");
            break;
          case "copy":
            navigator.clipboard.writeText(currentUrl).then(function () {
              copyMessage.classList.add("active");
              setTimeout(() => {
                copyMessage.classList.remove("active");
              }, 2000);
            });
            break;
        }
        sharePopover.classList.remove("active");
      });
    });
  }
  const shareIngredientsBtn = document.getElementById("share-ingredients");
  if (shareIngredientsBtn) {
    shareIngredientsBtn.addEventListener("click", function () {
      const ingredientsContainer = document.querySelector(".recipe__ingredients-list");
      let ingredientsList = "";
      const listElements = ingredientsContainer.querySelectorAll("li");
      if (listElements.length > 0) {
        listElements.forEach(item => {
          ingredientsList += `• ${item.innerText.trim()}\n`;
        });
      } else {
        const rawText = ingredientsContainer.innerText;
      }
      const recipeTitle = document.querySelector(".recipe__header h1").innerText.trim();
      const recipeUrl = window.location.href;
      let message = `*${recipeTitle} - Ingredientes:*\n\n`;
      message += ingredientsList;
      message += `\n\nVer receta completa: ${recipeUrl}`;
      const encodedMessage = encodeURIComponent(message);
      const whatsappUrl = `https://wa.me/?text=${encodedMessage}`;
      window.open(whatsappUrl, "_blank");
    });
  }

  // const videoQuad = document.querySelector(".video-quad");
  // if (videoQuad) {
  //   const video = videoQuad.querySelector("iframe");
  //   console.log("video", video);
  //   const playButton = videoQuad.querySelector(".play-video");

  //   playButton.addEventListener("click", function () {
  //     video.click();
  //     videoQuad.classList.add("active");
  //     //video.setAttribute("controls", "controls");
  //   });
  // }

  const open_menu = document.getElementById("open-menu");
  if (open_menu) {
    open_menu.addEventListener("click", () => {
      document.querySelector(".header").classList.add("mobile-open");
    });
  }
  const close_menu = document.getElementById("close-menu");
  if (close_menu) {
    close_menu.addEventListener("click", () => {
      document.querySelector(".header").classList.remove("mobile-open");
    });
  }
});
const actualBtn = document.querySelector(".form-field--file input[type='file']");
const fileChosen = document.querySelector(".form-field--file label");
if (actualBtn) {
  actualBtn.addEventListener("change", function () {
    fileChosen.textContent = this.files[0].name;
  });
}
const lineItems = document.querySelectorAll(".line-item");
if (lineItems) {
  lineItems.forEach(item => {
    const modal = document.querySelector(".timeline-modal");
    const thisTitle = item.querySelector(".line-item__title").innerHTML;
    const thisContent = item.querySelector(".line-item__text").innerHTML;
    item.addEventListener("click", function () {
      modal.querySelector(".timeline-modal__title").innerHTML = thisTitle;
      modal.querySelector(".timeline-modal__description").innerHTML = thisContent;
      modal.classList.add("active");
      document.querySelector("body").classList.add("lock-scroll");
    });
  });
  const closeModal = document.querySelector(".timeline-modal__close");
  if (closeModal) {
    closeModal.addEventListener("click", function () {
      const modal = document.querySelector(".timeline-modal");
      modal.classList.remove("active");
      document.querySelector("body").classList.remove("lock-scroll");
    });
  }
  const modalOverlay = document.querySelector(".timeline-modal__overlay");
  if (modalOverlay) {
    modalOverlay.addEventListener("click", function () {
      const modal = document.querySelector(".timeline-modal");
      modal.classList.remove("active");
      document.querySelector("body").classList.remove("lock-scroll");
    });
  }
}
const searchButton = document.querySelector(".header__search-button");
const searchInput = document.getElementById("site-search");
const searchClose = document.querySelector(".close-search");
if (searchClose) {
  searchClose.addEventListener("click", function () {
    document.getElementById("header").classList.remove("search-open");
    document.querySelector("body").classList.remove("lock-scroll");
  });
}
if (searchButton) {
  searchButton.addEventListener("click", function () {
    document.getElementById("header").classList.add("search-open");
    document.querySelector("body").classList.add("lock-scroll");
    searchInput.focus();
  });
  searchInput.addEventListener("focus", function () {
    document.getElementById("header").classList.add("search-focused");
  });
  searchInput.addEventListener("blur", function () {
    document.getElementById("header").classList.remove("search-focused");
  });
}
const menuItemWithChildren = document.querySelectorAll(".menu-item-has-children > a");
if (menuItemWithChildren) {
  menuItemWithChildren.forEach(item => {
    item.addEventListener("click", function (e) {
      e.preventDefault();
      const parent = this.parentElement;
      parent.classList.toggle("active");
    });
  });
}